import { Component, Input, OnInit } from '@angular/core';
import { AudanetCalculation } from '../../models/AudanetCalculation';

@Component({
  selector: 'app-show-calculation-details',
  templateUrl: './show-calculation-details.component.html',
  styleUrls: ['./show-calculation-details.component.scss']
})
export class ShowCalculationDetailsComponent implements OnInit {

  constructor() { }

  @Input() calculation:AudanetCalculation;

  ngOnInit(): void {
  }

}
